import { render, staticRenderFns } from "./settings-list-item.component.vue?vue&type=template&id=4ca4ae7e&scoped=true&"
import script from "./settings-list-item.component.vue?vue&type=script&lang=ts&"
export * from "./settings-list-item.component.vue?vue&type=script&lang=ts&"
import style0 from "./settings-list-item.component.vue?vue&type=style&index=0&id=4ca4ae7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca4ae7e",
  null
  
)

export default component.exports